import { LOADING, SET_MESSAGE, UPDATE_USER } from "../../Actions/Types";
import { updateUserProfileApi } from "../../Api/UserAction/UpdateUserDetails";
import { encryptPassword } from "../../Helpers/encryptPassword";
import { UserPropTypes } from "../../PropTypes/UserPropTypes";
import { EncryptedDataPropTypes } from "../../PropTypes/EncryptedDataPropTypes";

// service to handle user information update
const updateUserService = async (
    user: UserPropTypes, // user data
    accessToken: string, // access token    
    dispatch: Function, // dispatch function to store redux data
    t: Function, // i18n t function
    password?: string, // password 
    otp?: string,
) => {

    // set loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    const secretKey = process.env.REACT_APP_SECRET_KEY;

    if (password) {
        let encryptedPasswordObj: EncryptedDataPropTypes | null = null;
        encryptedPasswordObj = await encryptPassword(password, secretKey as string);
        // API to update user profile
        updateUserProfileApi(user, accessToken, encryptedPasswordObj, otp).then(response => {

            // check if response data is available
            if (response.Data) {
                // dispatch user data
                dispatch({
                    type: UPDATE_USER,
                    payload: { user: response.Data },
                });

                // remove loading
                dispatch({
                    type: LOADING,
                    payload: false,
                });

                // dispatch profile update successfully message
                dispatch({
                    type: SET_MESSAGE,
                    payload: {
                        "toast_message": t("Profile Update Success Msg", { returnObjects: true }),
                        "toast_type": "success"
                    }
                });
            }
            else {

                // remove loading
                dispatch({
                    type: LOADING,
                    payload: false,
                });

                // dispatch update profile failure message
                dispatch({
                    type: SET_MESSAGE,
                    payload: {
                        "toast_message": t("Profile Update failed Msg", { returnObjects: true }),
                        "toast_type": "danger"
                    }
                });
            }
        });
    }
    else {
        // API to update user profile
        updateUserProfileApi(user, accessToken).then(response => {

            // check if response data is available
            if (response.Data) {
                // dispatch user data
                dispatch({
                    type: UPDATE_USER,
                    payload: { user: response.Data },
                });

                // remove loading
                dispatch({
                    type: LOADING,
                    payload: false,
                });

                // dispatch profile update successfully message
                dispatch({
                    type: SET_MESSAGE,
                    payload: {
                        "toast_message": t("Profile Update Success Msg", { returnObjects: true }),
                        "toast_type": "success"
                    }
                });
            }
            else {

                // remove loading
                dispatch({
                    type: LOADING,
                    payload: false,
                });

                // dispatch update profile failure message
                dispatch({
                    type: SET_MESSAGE,
                    payload: {
                        "toast_message": t("Profile Update failed Msg", { returnObjects: true }),
                        "toast_type": "danger"
                    }
                });
            }
        });
    }



}

export { updateUserService }